import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiFormControl-root": {
      marginTop: theme.spacing(2),
    },
  },
  linkTag: {
    textDecoration: "none",
    "& :hover": {
      color: "grey",
    },
  },
  grid: {
    width: "100%",
  },
  loginButton: {
    marginTop: theme.spacing(2),
  },
  forgetPasswordButton: {
    marginTop: theme.spacing(-1),
  },
  resendOtp: {
    marginTop: theme.spacing(-2),
    marginBottom: theme.spacing(1),
  },
  labelStyles: {
    marginBottom: theme.spacing(-1),
    marginTop: theme.spacing(2),
  },
}));

export default useStyles;
